/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React from 'react';
import { Route } from 'react-router';

import ErrorBoundaryRoutes from 'app/shared/error/error-boundary-routes';

import DiaglabDepartmentAccess from './diaglab-department-access';
import DiaglabDepartmentAccessDetail from './diaglab-department-access-detail';
import DiaglabDepartmentAccessUpdate from './diaglab-department-access-update';
import DiaglabDepartmentAccessDeleteDialog from './diaglab-department-access-delete-dialog';

const DiaglabDepartmentAccessRoutes = () => (
  <ErrorBoundaryRoutes>
    <Route index element={<DiaglabDepartmentAccess />} />
    <Route path="new" element={<DiaglabDepartmentAccessUpdate />} />
    <Route path=":id">
      <Route index element={<DiaglabDepartmentAccessDetail />} />
      <Route path="edit" element={<DiaglabDepartmentAccessUpdate />} />
      <Route path="delete" element={<DiaglabDepartmentAccessDeleteDialog />} />
    </Route>
  </ErrorBoundaryRoutes>
);

export default DiaglabDepartmentAccessRoutes;
